module.exports = __webpack_public_path__ + "img/ulrike-gerd.61613873.jpg";